var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: _vm.computedClasses },
    [
      _c(
        "div",
        { class: { "input-group": _vm.grpPrependSlot || _vm.grpAppendSlot } },
        [
          _vm.grpPrependSlot
            ? _c(
                "div",
                { staticClass: "input-group-prepend" },
                [_vm._t("grpPrepend")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-select", {
            key: _vm.id,
            staticClass: "city-select",
            class: [
              _vm.inputClasses,
              { "vs--selected": _vm.hasValue, nowrap: _vm.noWrap },
            ],
            attrs: {
              taggable: _vm.allowCreate,
              pushTags: _vm.pushTags,
              name: _vm.name,
              inputId: _vm.id,
              label: _vm.label,
              autocomplete: _vm.autocomplete,
              placeholder: _vm.placeholder,
              filterable: _vm._filterable,
              options: _vm.optionsList,
              clearable: _vm.clearable,
              searchable: _vm.searchable,
              multiple: _vm.multiple,
              reduce: _vm.reduceItem,
              noDrop: _vm.noDrop,
              disabled: _vm.disabled,
              resetOnOptionsChange: _vm.resetOnOptionsChange,
              appendToBody: _vm.appendToBody,
              createOption: _vm.createOption,
              loading: _vm.loadingSpinner,
            },
            on: {
              input: _vm.handleModelInput,
              "option:selected": _vm.onSelected,
              "search:focus": function ($event) {
                return _vm.handleFocus(true)
              },
              "search:blur": function ($event) {
                return _vm.handleFocus(false)
              },
              search: _vm.onSearch,
              open: _vm.onOpen,
              close: _vm.onClose,
              "option:created": _vm.optionCreated,
              "option:selecting": _vm.optionSelecting,
            },
            scopedSlots: _vm._u(
              [
                !_vm.multiple
                  ? {
                      key: "search",
                      fn: function ({ attributes, events }) {
                        return [
                          _c(
                            "input",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "vs__search",
                                  on: {
                                    keydown: _vm.onInputSerachHandleKeydown,
                                    blur: _vm.onInputSearchBlur,
                                  },
                                },
                                "input",
                                _vm.getInputSearchLabel(attributes),
                                false
                              ),
                              events
                            )
                          ),
                        ]
                      },
                    }
                  : null,
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      _vm._t(
                        "selected-option",
                        function () {
                          return [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.getOptionLabel(option)) +
                                "\n                "
                            ),
                          ]
                        },
                        {
                          option:
                            _vm.initialData &&
                            _vm.valueCopy &&
                            _vm.reduce(_vm.initialData) === _vm.valueCopy
                              ? _vm.initialData
                              : option,
                          label: _vm.label,
                        }
                      ),
                    ]
                  },
                },
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _vm._t(
                        "option",
                        function () {
                          return [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.getOptionHtml(option)),
                              },
                            }),
                          ]
                        },
                        { option: option, label: _vm.label }
                      ),
                    ]
                  },
                },
                {
                  key: "list-footer",
                  fn: function () {
                    return [
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasNextPage && _vm.infiniteScroll,
                              expression: "hasNextPage && infiniteScroll",
                            },
                          ],
                          staticClass: "loader",
                          attrs: { id: `loadMore-${_vm.uniqueId}` },
                        },
                        [
                          _vm._v(
                            "\n                    A carregar mais opções...\n                "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "no-options",
                  fn: function ({ search, searching }) {
                    return [
                      searching
                        ? [_vm._v(" Nenhum resultado encontrado ")]
                        : _c("em", { staticStyle: { opacity: "0.5" } }, [
                            _vm._v("Comece a escrever para pesquisar"),
                          ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.valueCopy,
              callback: function ($$v) {
                _vm.valueCopy = $$v
              },
              expression: "valueCopy",
            },
          }),
          _vm._v(" "),
          _vm.grpAppendSlot
            ? _c(
                "div",
                {
                  staticClass: "input-group-append",
                  class: _vm.grpAppendClass,
                },
                [_vm._t("grpAppend")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "material-label",
              class: _vm.activeClass,
              attrs: { for: _vm.id },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.error
            ? _c("small", { staticClass: "invalid-feedback" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("HelpSpan", { attrs: { helpText: _vm.helpText } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }